import React from "react";
import "./Inputs.scss";
import { FormFields, useRegistration } from "../../contexts/RegistrationContext";
import { Input, Select, Form } from "antd";

const { Option } = Select;

export const OrangeRegistrationInput = ({
  registrationKey,
  type = "text",
  style = {},
  missingFields: missingFieldsProp = [],
}) => {
  const {
    formData,
    setFormKey,
    formOptions,
    formMessages,
    formTitles,
    referralLocked,
  } = useRegistration();
  const isKeyMissing = missingFieldsProp.includes(registrationKey);
  const isReferrerCode =
    registrationKey === FormFields.ADDITIONAL_INFO.RECOMMENDED_BY;

  const title = formTitles[registrationKey];
  const value = formData[registrationKey];
  const onChange = (val) => {
    const eventValue = val?.target ? val.target.value : val;
    setFormKey(registrationKey, eventValue);
  };
  const message = formMessages[registrationKey];
  // Referrer is code-only text — never expose agent list options in the UI.
  const options = isReferrerCode ? null : formOptions[registrationKey];

  const placeholders = {
    email: "your@email.com",
    cell: "לדוגמה: 050-0000000",
    firstName: "כפי שמופיע בתעודה",
    lastName: "כפי שמופיע בתעודה",
    companyName: "שם העסק כפי שרשום",
    companyNumber: "מספר עוסק / ח.פ.",
    passwordAgain: "הזן שוב את הסיסמה",
    recommendedBy: "קוד סוכן (לא חובה)",
  };
  const placeholder = placeholders[registrationKey];

  return (
    <Form.Item
      label={
        <span
          style={{
            fontWeight: 600,
            fontSize: 15,
            lineHeight: 1.5,
            color: "#262626",
          }}
        >
          {title}
        </span>
      }
      validateStatus={isKeyMissing ? "error" : undefined}
      help={isKeyMissing ? message || "שדה חובה" : undefined}
      className="agent-reg-field-item"
    >
      {options ? (
        <Select
          value={value || undefined}
          onChange={onChange}
          placeholder={placeholder || "בחרו מהרשימה"}
          size="large"
          style={{ borderRadius: 8, ...style }}
        >
          {options.map((p) => (
            <Option key={p.value} value={p.value}>
              {p.name}
            </Option>
          ))}
        </Select>
      ) : type === "password" ? (
        <Input.Password
          type={type}
          value={value}
          onChange={onChange}
          size="large"
          placeholder={placeholder || "לפחות 8 תווים"}
          style={{ borderRadius: 8, ...style }}
        />
      ) : (
        <Input
          type="text"
          value={value ?? ""}
          onChange={onChange}
          size="large"
          placeholder={placeholder}
          allowClear={isReferrerCode ? !referralLocked : undefined}
          disabled={isReferrerCode ? Boolean(referralLocked) : undefined}
          autoComplete={isReferrerCode ? "off" : undefined}
          style={{ borderRadius: 8, ...style }}
        />
      )}
    </Form.Item>
  );
};
